import { getImportanceSortRank } from './sortRowsByImportance';

/** Folder Importance seeks equality, then falls back to End when the selected group is absent. */
export default function findImportanceJumpToIndex<T>(
    rows: readonly T[],
    getImportance: (row: T) => string | null | undefined,
    matchingString: string
): number {
    if (matchingString !== 'High' && matchingString !== 'Normal' && matchingString !== 'Low') {
        return -1;
    }
    const targetRank = getImportanceSortRank(matchingString);
    const exactIndex = rows.findIndex(
        row => getImportanceSortRank(getImportance(row)) === targetRank
    );
    return exactIndex >= 0 ? exactIndex : rows.length - 1;
}
